import React, { useState } from "react";
import { connect } from "react-redux";
import AllProductList from "./AllProductList";
import ViewProduct from "./ViewProduct";
import SingleProductDetailsTable from "./SingleProductDetailsTable";
import CreateProduct from "./SingleProduct/CreateProduct";

import { Layout, Breadcrumb, Row, Col, Button } from "antd";
const { Content } = Layout;

const ProductDetails = () => {
  const [updatelist, setUpdatelist] = useState(true);
  const [trigger, settrigger] = useState(true);
  const [details, setdetails] = useState([]);

  const [drawerOpen, setDrawerOpen] = useState(false);

  const openDrawer = () => setDrawerOpen(true);
  const closeDrawer = () => setDrawerOpen(false);

  // Callback function to refresh the product list after creation
  const handleProductCreated = () => {
    setUpdatelist((prev) => !prev);
  };

  const setselectedproduct = (trigger, details) => {
    settrigger(trigger);
    setdetails(details);
  };

  const renderdata = () => {
    if (trigger) {
      return (
        <AllProductList
          updatelist={updatelist}
          setUpdatelist={setUpdatelist}
          setselectedproduct={setselectedproduct}
        />
      );
    } else {
      return (
        <SingleProductDetailsTable
          setUpdatelist={setUpdatelist}
          details={details}
          settrigger={settrigger}
        />
      );
    }
  };

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Products</Breadcrumb.Item>
        <Breadcrumb.Item>All</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">
        <div style={{ textAlign: "right", marginBottom: 16 }}>
          <Button type="primary" onClick={openDrawer}>
            + Create Product
          </Button>
        </div>

        <Row>
          <Col span={24}>{renderdata()}</Col>
        </Row>

        <CreateProduct
          open={drawerOpen}
          onClose={closeDrawer}
          setUpdatelist={setUpdatelist}
          onSuccess={handleProductCreated}
        />
      </div>
    </>
  );
};

export default connect()(ProductDetails);